import { render } from "./BpSpinner.vue?vue&type=template&id=37de6b14&scoped=true"
import script from "./BpSpinner.vue?vue&type=script&lang=js"
export * from "./BpSpinner.vue?vue&type=script&lang=js"

import "./BpSpinner.vue?vue&type=style&index=0&id=37de6b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37de6b14"]])

export default __exports__